import { render } from "./LeadsDetailView.vue?vue&type=template&id=c02e1db4&scoped=true"
import script from "./LeadsDetailView.vue?vue&type=script&lang=js"
export * from "./LeadsDetailView.vue?vue&type=script&lang=js"

import "./LeadsDetailView.vue?vue&type=style&index=0&id=c02e1db4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02e1db4"]])

export default __exports__